import axios from 'axios';
import i18n from '@app/i18n';
import { normalizeApiError, shouldNotifyApiError } from '@app/api/errorNormalizer';
import { beginSessionEnd } from '@app/api/sessionState';
import { notifyNormalizedApiError } from '@app/utils/notifyApiError';
import { captureUnhandledError } from '@app/services/sentryService';

/**
 * Catches promise rejections that no `catch` handled. Axios failures are skipped:
 * the response interceptor already reports those.
 */
export const registerGlobalErrorHandlers = (): void => {
  // Requests still in flight when the page goes away are not the user's problem.
  window.addEventListener('pagehide', beginSessionEnd);
  window.addEventListener('beforeunload', beginSessionEnd);

  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    console.error('[unhandledrejection]', reason);

    if (axios.isAxiosError(reason)) {
      return;
    }

    // Captured here rather than by Sentry's own handler, so the toast can show the
    // same reference id (see `globalHandlersIntegration` in `sentryService`).
    const referenceId = captureUnhandledError(reason);

    const normalized = normalizeApiError(reason);
    if (!shouldNotifyApiError(normalized)) {
      return;
    }

    notifyNormalizedApiError(i18n.t, normalized, referenceId);
  });
};
